import React from "react";
import graphql from "graphql";
import Layout from "./index";
import { addLocaleData } from "react-intl";

import messages from "../data/messages/en";
import en from "react-intl/locale-data/en";
import "intl/locale-data/jsonp/en";

addLocaleData(en);

export default props => <Layout {...props} i18nMessages={messages} />;

export const pageQuery = graphql`
  query LayoutEn {
    site {
      siteMetadata {
        title
        languages {
          defaultLangKey
          langs
        }
      }
    }

    consulting01: file(name: { eq: "01consulting" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    sindicatos02: file(name: { eq: "02sindicatos" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    outsourcing03: file(name: { eq: "03outsourcing" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    bg: file(name: { eq: "bg" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    about: file(name: { eq: "about" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }

    outsourcing: file(name: { eq: "outsourcing" }) {
      childImageSharp {
        sizes {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/en.js